<template>
  <!-- 数据汇总 -->
  <el-card class="card-content">
    <div style="display: flex">
      <div class="card-box-col" v-if="option" @click="handlerClick(option)" :class="{ 'disable-card': option.disable }">
        <div class="title">
          <span style="color: #8a909d">{{ option.title }}</span>

          <template v-if="option.tooltip">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                <div v-html="option.tooltip"></div>
              </div>
              <i class="icon-a-01wenhao iconfont-el icon"></i>
            </el-tooltip>
          </template>
        </div>
        <div class="content font-manrope">
          <el-tooltip placement="top">
            <span
              style="color: #0560fd; cursor: pointer"
              v-html="option.prefix"
              @click="handlerClickPre(option)"
            ></span>
            <template slot="content">
              {{ option.preTooltip }}
            </template>
          </el-tooltip>
          {{ option.count }}
          <span style="font-size: 16px">{{ option.suffix }}</span>
          <span class="currency-icon" v-if="option.current">{{ option.current }}</span>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'Card',
  props: {
    option: {
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handlerClick(option) {
      this.$emit('click', option)
    },
    handlerClickPre(option) {
      this.$emit('clickPre', option)
    },
  },
}
</script>
<style lang="scss" scoped>
.card-content {
  padding: 6px 16px;
  // cursor: pointer;
  min-height: 96px;
  .currency-icon {
    font-size: 14px !important;
    // margin-left: 4px;
  }
  .card-box-col {
    position: relative;
    flex: 1;
  }
  a {
    color: #556aff;
    position: absolute;
    right: 0;
    top: 0;
  }
  .title {
    font-size: 12px;
  }
  .icon {
    color: #999999;
    margin-left: 8px;
    font-size: 14px;
  }
  .rate {
    position: relative;
    bottom: 0;
    right: 0;
    font-size: 14px;
    color: #00ce47;
    display: block;
    display: flex;
    align-items: center;
    margin-top: 20px;
    &.t {
      color: #ff0022;
    }
    span {
      font-weight: bold;
    }
  }
  .c-icon {
    font-size: 20px;
    font-weight: bold;
    margin-left: 4px;
  }
  .content {
    margin-top: 12px;
    font-size: 22px;
    font-weight: bold;
  }
  &.active {
    color: #fff !important;
    background-color: #556aff;
    .icon {
      color: #fff !important;
      margin-left: 9px;
      font-size: 14px;
    }
    a {
      color: #fff;
    }
    .rate {
      position: relative;
      bottom: 0;
      right: 0;
      color: #fff;
      margin-top: 4px;

      &.t {
        color: #fff;
      }
    }
  }
  @media screen and (min-width: 1600px) {
    // .content {
    //   font-size: 28px;
    // }
    // .c-icon {
    //   font-size: 24px;
    // }
    .rate {
      position: absolute;
      margin-top: 0px;
      bottom: 0;
      right: 0;
      display: inline-block;
      margin-top: 0px;
      // font-size: 20px;
    }
    &.active {
      .rate {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
}
.disable-card {
  color: #f0f2f5 !important;
}
.card-icon {
  width: 58px;
  height: 58px;
  background: #ecf2ff;
  border-radius: 50%;
  text-align: center;
  line-height: 58px;
  margin-right: 24px;
  .iconfont {
    font-size: 30px;
    color: #0560fd;
  }
}
</style>
